import { render, staticRenderFns } from "./WorkflowChatEntry.vue?vue&type=template&id=73eb1dfa&scoped=true"
import script from "./WorkflowChatEntry.vue?vue&type=script&lang=js"
export * from "./WorkflowChatEntry.vue?vue&type=script&lang=js"
import style0 from "./WorkflowChatEntry.vue?vue&type=style&index=0&id=73eb1dfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73eb1dfa",
  null
  
)

export default component.exports